import { createSlotFill } from '@eventespresso/slot-fill';

const { Slot: NewDateOptions, Fill: NewDateOption } = createSlotFill('NewDateOptions');

export { NewDateOption, NewDateOptions };
